import React from 'react';
import { FormStatus as StatusType } from '../../types';

interface FormStatusProps {
  status: StatusType;
}

const FormStatus: React.FC<FormStatusProps> = ({ status }) => {
  if (status === 'idle') return null;

  const statusConfig = {
    success: {
      className: 'text-green-600',
      message: 'Message envoyé avec succès !'
    },
    error: {
      className: 'text-red-600',
      message: 'Une erreur est survenue. Veuillez réessayer.'
    },
    sending: null
  };

  const config = statusConfig[status];
  if (!config) return null;

  return (
    <div className={`text-center py-2 ${config.className}`}>
      {config.message}
    </div>
  );
};

export default FormStatus;